import { render } from "./PlayerControls.vue?vue&type=template&id=449358dc"
import script from "./PlayerControls.vue?vue&type=script&lang=js"
export * from "./PlayerControls.vue?vue&type=script&lang=js"

import "./PlayerControls.vue?vue&type=style&index=0&id=449358dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__